import * as Yup from "yup";

import { FEE_AMOUNT_TYPE } from "@/constant/Payment/fee-amount-type";
import { FEE_ENTITY } from "@/constant/Payment/fee-entity";

const getPlatformFeeSchema = () =>
  Yup.object().shape({
    currency_code: Yup
      .string()
      .label("Currency")
      .required()
      .max(3),
    entity_type: Yup
      .string()
      .label("Fee Party")
      .required()
      .oneOf(Object.values(FEE_ENTITY)),
    amount_type: Yup
      .string()
      .label("Fee Type")
      .required()
      .oneOf(Object.values(FEE_AMOUNT_TYPE)),
    amount: Yup
      .number()
      .label("Rate")
      .required()
      .test(
        "decimal-places",
        "Rate must have at most 2 decimal places",
        (value) => {
          if (!value) return true; // Allow empty values (if required)
          return /^\d+(\.\d{1,2})?$/.test(value.toString());
        }
      )
  });

export default getPlatformFeeSchema;
